import CreateEventInfo from '@/pages/CreateEventProcessingPage/ui/CreateEventInfo.vue'
import CreateEventDate from '@/pages/CreateEventProcessingPage/ui/CreateEventDate.vue'
import CreateEventBattles from '@/pages/CreateEventProcessingPage/ui/CreateEventBattles.vue'
import CreateEventTotal from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal.vue'
import CreateEventDisplayMode from '@/pages/CreateEventProcessingPage/ui/CreateEventDisplayMode.vue'
import CreateEventPaymentMode from '@/pages/CreateEventProcessingPage/ui/CreateEventPaymentMode.vue'
import CreateEventOwnPaymentSystem from '@/pages/CreateEventProcessingPage/ui/CreateEventOwnPaymentSystem.vue'
import CreateEventBankAccount from '@/pages/CreateEventProcessingPage/ui/CreateEventBankAccount.vue'
import CreateEventTickets from '@/pages/CreateEventProcessingPage/ui/CreateEventTickets.vue'
import CreateEventRefundPolicy from '@/pages/CreateEventProcessingPage/ui/CreateEventRefundPolicy.vue'
import CreateEventGuestList from '@/pages/CreateEventProcessingPage/ui/CreateEventGuestList.vue'

const DEFAULT_PAGE_TITLE = 'Create Event'
const DEFAULT_PAGE_DESCRIPTION =
  'All fields here are required, unless otherwise noted as optional, to be filled out to move on to the next step'

export const CREATE_EVENT_FORMS = {
  info: {
    pageTitle: DEFAULT_PAGE_TITLE,
    pageDescription: DEFAULT_PAGE_DESCRIPTION,
    form: CreateEventInfo,
  },
  date: {
    pageTitle: DEFAULT_PAGE_TITLE,
    pageDescription: DEFAULT_PAGE_DESCRIPTION,
    form: CreateEventDate,
  },
  battles: {
    pageTitle: DEFAULT_PAGE_TITLE,
    pageDescription: DEFAULT_PAGE_DESCRIPTION,
    form: CreateEventBattles,
  },
  total: {
    pageTitle: DEFAULT_PAGE_TITLE,
    pageDescription: DEFAULT_PAGE_DESCRIPTION,
    form: CreateEventTotal,
  },
  'display-mode': {
    pageTitle: DEFAULT_PAGE_TITLE,
    pageDescription: DEFAULT_PAGE_DESCRIPTION,
    form: CreateEventDisplayMode,
  },
  'payment-mode': {
    pageTitle: DEFAULT_PAGE_TITLE,
    pageDescription: DEFAULT_PAGE_DESCRIPTION,
    form: CreateEventPaymentMode,
  },
  'own-payment-mode': {
    pageTitle: DEFAULT_PAGE_TITLE,
    pageDescription: DEFAULT_PAGE_DESCRIPTION,
    form: CreateEventOwnPaymentSystem,
  },
  'bank-account': {
    pageTitle: 'Break Konnect Payment System',
    pageDescription: undefined,
    form: CreateEventBankAccount,
  },
  tickets: {
    pageTitle: 'Tickets',
    pageDescription: undefined,
    form: CreateEventTickets,
  },
  'refund-policy': {
    pageTitle: 'Tickets',
    pageDescription: undefined,
    form: CreateEventRefundPolicy,
  },
  guests: {
    pageTitle: DEFAULT_PAGE_TITLE,
    pageDescription: DEFAULT_PAGE_DESCRIPTION,
    form: CreateEventGuestList,
  },
} as const

export type TCreateEventFormKey = keyof typeof CREATE_EVENT_FORMS
export type TCreateEventFormComponent = (typeof CREATE_EVENT_FORMS)[TCreateEventFormKey]
